import { useRef } from 'react';

import { useAtomValue } from 'jotai';
import { InputVideoTrack } from 'mediabunny';

import { comparisonTotalFrames, currentFrameAtom, syncedFrameAtom, totalFramesAtom } from '@store';

import { useVideo, VIDEO_STATUS, VideoMetadata } from '../hooks/useVideoCache';
import { useVideoFrames } from '../hooks/useVideoFrames';
import { VIDEO_TYPE, VideoTypeByOrigin } from '../utils/consts';

import * as styles from './styles.css';

type VideoPlayerProps = {
    src: string;
    origin: VideoTypeByOrigin;
};

type VideoCanvasProps = {
    origin: VideoTypeByOrigin;
    src: string;
    track: InputVideoTrack;
    metadata: VideoMetadata;
};

const VideoCanvas = ({ origin, ...rest }: VideoCanvasProps) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const frame = useAtomValue(origin === VIDEO_TYPE.CURRENT ? currentFrameAtom : syncedFrameAtom);
    const frameCount = useAtomValue(origin === VIDEO_TYPE.CURRENT ? totalFramesAtom : comparisonTotalFrames);
    useVideoFrames(canvasRef, frame, frameCount, rest);
    return <canvas ref={canvasRef} className={styles.media} />;
};

export function VideoPlayer(props: VideoPlayerProps) {
    const state = useVideo(props.src);

    return (
        <>
            {state.status === VIDEO_STATUS.READY && <VideoCanvas {...props} {...state} />}
            {state.status !== VIDEO_STATUS.READY && <div className={styles.statusOverlay}>{state.status}</div>}
        </>
    );
}
